<template>
  <tr :class="['clickable', {deleted: isDeleted, disabled: !isActive}]" @click="goToDetail($event, item.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input
          type="checkbox"
          :id="item.id"
          :value="item.id"
          @change="onChange"
          :checked="isChecked"
          @click.stop
      />
      <label :for="item.id" @click.stop v-translate>Vybrat</label>
    </td>
    <td :data-th="'Název odběratele' | translate" class="first_data"><strong>{{ item.name }}</strong></td>
    <td :data-th="'Balíčky' | translate">
      <span v-if="item.channel_package_count > 0" class="dotted">{{item.channel_package_count}}
      <ReportsValueDifference columnName="channel_package_count_change" :data="item" />
                <span class="help_popup">
              <ul>
                  <li v-for="(packageId, index) in item.packageIds" :key="index">
                      {{ packageNames[packageId].name }}
                  </li>
              </ul>
          </span>
      </span>
      <span v-else>0
        <ReportsValueDifference columnName="channel_package_count_change" :data="item" />
      </span>
    </td>
    <td :data-th="'Počet simultánně streamujících zařízení nad limit' | translate" class="first_data">{{item.paidDeviceCount}}
      <ReportsValueDifference columnName="paidDeviceCount_change" :data="item" />
    </td>
    <td :data-th="'Počet firstscreen zařízení nad limit' | translate" class="first_data">{{item.firstscreenDeviceAboveLimitCount}}
      <ReportsValueDifference columnName="firstscreenDeviceAboveLimitCount_change" :data="item" />
    </td>
    <td :data-th="'Testovací odběratel' | translate" class="first_data"><img :class="['is_set']" src="../../../assets/images/is-set.svg" :alt="'Ano' | translate" v-show="item.tester"></td>
    <td class="last_data right">
      <img v-if="isDeleted" class="state_icon" src="../../../assets/images/smazany.svg" alt="Smazaný odběratel" :title="$gettext('Smazaný odběratel')"/>
      <img v-if="isNew" class="state_icon" src="../../../assets/images/novy.svg" alt="Nový odběratel" :title="$gettext('Nový odběratel')" />
      <img v-if="!isActive && toActive" class="state_icon state_icon_wide" src="../../../assets/images/neaktivni.svg" alt="Neaktivní odběratel" :title="$gettext('Neaktivní odběratel')" />
      <img v-if="toActive" class="state_icon state_icon_wide" src="../../../assets/images/neaktivni-aktivni.svg" alt="Neaktivní odběratel se stal aktivním" :title="$gettext('Neaktivní odběratel se stal aktivním')" />
      <img v-if="toInactive" class="state_icon state_icon_wide" src="../../../assets/images/aktivni-neaktivni.svg" alt="Aktivní odběratel se stal neaktivním" :title="$gettext('Aktivní odběratel se stal neaktivním')" />
      <img v-if="item.tester_change === true" class="state_icon state_icon_wide" src="../../../assets/images/klasicky-testovaci.svg" alt="Testovací odběratel se stal klasickým" :title="$gettext('Testovací odběratel se stal klasickým')" />
      <img v-if="item.tester_change === false" class="state_icon state_icon_wide" src="../../../assets/images/testovaci-klasicky.svg" alt="Klasický odběratel se stal testovacím" :title="$gettext('Klasický odběratel se stal testovacím')" />
    </td>
  </tr>
</template>

<script>
import ReportsValueDifference from "./ReportsValueDifference";

export default {
  name: "ReportsOperatorRow",
  components: {ReportsValueDifference},
  props: {
    item: Object,
    packageNames: Object,
    selectedItems: Array,
  },
  computed:{
    isChecked: function () {
      return this.selectedItems.indexOf(String(this.item.id)) > -1
    },
    isDeleted: function (){
      return this.item.changeFlag === "deleted";
    },
    isNew: function (){
      return this.item.changeFlag === "new";
    },
    toActive: function (){
      return this.item.changeFlag === "toActive";
    },
    toInactive: function (){
      return this.item.changeFlag === "toInactive";
    },
    isActive: function (){
      return this.item.active;
    }

  },
  methods:{
    goToDetail(e, id) {
      this.$router.push({name: 'subscriberDetail', params: {id: id}})
    },
    onChange: function (e) {
      this.$emit('input', e)
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/reports/ReportsOperatorRow.vue